module.exports = __webpack_public_path__ + "img/coordinates_s.21206c1d.png";